import useColors from "../../../../api/hooks/useColors";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

const DeleteControlButton = ({ handleOnClick }) => {
  const colors = useColors();

  return (
    <PrimaryButton
      onClick={handleOnClick}
      style={{
        color: colors.common_white,
        backgroundColor: colors.error_main,
        borderRadius: "8px",
        border: "none",
        fontWeight: "bold",
      }}
      size="small"
    >
      Delete Control (RESTRICTED)
    </PrimaryButton>
  );
};

export default DeleteControlButton;
